import { apolloClient } from "@App/graphql/client";
import { GET_SERVICES, type ServicesQuery } from "@App/graphql/queries";
import { actionCreators, type State, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useServiceParameters = () => {
  const dispatch = useDispatch();
  const { chooseService } = bindActionCreators(actionCreators, dispatch);
  const { serviceSlug } = useParams();
  const [searchParams] = useSearchParams();

  const organization = useSelector((state: State) => state.orders.organization);
  const service = useSelector((state: State) => state.orders.service);
  const serviceQuery = parseInt(searchParams.get("service") ?? "");

  useEffect(() => {
    if (!serviceQuery) {
      if (!serviceSlug) chooseService(null);
      return;
    }

    // get service from api if not in state
    if (
      (serviceSlug && (!service || service.slug !== serviceSlug)) ||
      (serviceQuery && (!service || service.id != serviceQuery))
    ) {
      apolloClient
        .query<ServicesQuery>({
          query: GET_SERVICES,
          variables: {
            organization: organization?.id,
            ...(serviceQuery && {
              service: service ? service.id : serviceQuery,
            }),
            ...(serviceSlug && !serviceQuery && { slug: serviceSlug }),
          },
        })
        .then((result) => {
          chooseService(result?.data?.organization?.services?.[0] ?? null);
        });
    }
  }, [serviceQuery]);

  // // if service or place changes, automatically update the query parameters
  // useEffect(() => {
  //     if (service && service.id != searchParams.get('service')) {
  //         searchParams.set('service', service.id.toString())
  //     }
  // }, [service])

  const serviceQueryParams = (): Record<string, string> => {
    return {
      // add service if existing
      ...(store.getState().orders.service && {
        service: store.getState().orders.service?.id?.toString(),
      }),
    };
  };

  return { serviceQueryParams };
};
